goog.provide('el8.ext.onboarding.quickSignup');

goog.require('el8.core.service.UILayout');
goog.require('el8.ext.Form');
goog.require('el8.ext.onboarding.ButtonSet');
goog.require('el8.ext.onboarding.notDoctorDialog');
goog.require('el8.ext.util');
goog.require('el8.template.ext.onboarding.identityForm');
goog.require('el8.template.ext.onboarding.quickSignup');
goog.require('el8.uiwidget.NewPasswordFields');
goog.require('el8.util.base');


el8.ext.onboarding.quickSignup.init = function() {

    Cookies.json = true;

    var $container = $('#form-onboarding').removeClass('dataLoading');
    $container.html(el8.template.ext.onboarding.quickSignup.content({
        activating: el8.util.getUrlParam('activate')
    }));

    var $searchArea = $('.onboarding-profile-search', $container);
    var $profileDisplay = $('.onboarding-profile-display', $container);
    var $emailPwd = $('.onboarding-email-pwd', $container);
    var $form = $('form', $container);

    var _profileId = null;

    var validationOpts = el8.ext.util.validationOpts();
    validationOpts['errorPlacement'] = function(error, element) {
        var name = $(element).attr('name');
        $(error).attr('data-name', name);
        var $existing = $(element).prev('.error-msg');
        if ($existing.length) {
            $existing.replaceWith($(error));
        } else {
            $(error).insertBefore($(element));
        }
    };
    validationOpts['unhighlight'] = function(element, errorClass) {
        el8.ext.util.unhighlightError($(element));
        $(element).prevAll('.error-msg').empty();
    };

    var _GAtrackSearch = _.once(function() {
        _gaq.push(['_trackPageview', el8Globals['OB']+'page-quick-signup/search/']);
    });

    var UILayout = (new el8.core.service.UILayout()).setup();

    var that = new el8.ext.Form({
        container: $form,
        name: 'quick-signup',
        buttonElt: $('.onboarding-signup-buttons', $form),
        buttonSetConstructor: el8.ext.onboarding.ButtonSet,
        validationOpts: validationOpts,
        fields: [
            {
                name: 'profileSearch',
                selector: ':input[name="profileSearch"]',
                infoText: 'Start typing your name...',
                size: 'xl',
                maxLength: 200,
                newMindreader: true,
                mindreaderOpts: {
                    url: el8.service.urls.get('profileLookup'),
                    UILayoutFn: function() { return UILayout; },
                    formatResult: function(item) {
                        _GAtrackSearch();
                        return el8.template.ext.onboarding.identityForm.profileResult({item: item});
                    },
                    formatSelected: function(item) {
                        return item.first_name + ' ' + item.last_name;
                    },
                    selectFn: function(e, item) {
                        _gaq.push(['_trackPageview', el8Globals['OB']+'page-quick-signup/selected-self/']);
                        olark && olark('api.visitor.updateFullName', {fullName: item.first_name + ' ' + item.last_name});
                        that._waitProfileDisplay();
                        that._validateProfile(item,
                            function() {
                                that._showProfileDisplay(item);
                                _profileId = item.id;
                            },
                            function() {
                                // this NPI already has a test account associated with it
                                if (el8.util.getUrlParam('activate') && item.npi) {
                                    // the user wants to sign up directly - we can activate the existing account
                                    var mapped = { npi: item.npi };
                                    $.el8_ajax({
                                        type: 'POST',
                                        async: false,
                                        data: {data: JSON.stringify(mapped)},
                                        url: el8.service.urls.get('activateExisting'),
                                        success: function(data) {
                                            that._writeSignedUpCookie();
                                            window.location.href = el8.service.urls.get('signupComplete', [true]);
                                        },
                                        error: function() {
                                            window.location.href = el8.service.urls.get('signupError', [true]);
                                        }
                                    });
                                } else {
                                    // test account signup - this is a duplicate
                                    that._showProfileDisplay(item, true);
                                }
                            }
                        );
                    },
                    actions: [
                        {
                            name: 'Don\'t see your profile? Manually sign up here',
                            actionFn: function() {
                                _gaq.push(['_trackPageview', el8Globals['OB']+'page-quick-signup/cant-find-self/']);
                                var url = '/manual-signup/?name='+that.getVal('profileSearch');
                                if (el8.util.getUrlParam('activate')) { url += '&activate=true'; }
                                window.location.href = url;
                            }
                        }
                    ]
                }
            },
            {
                name: 'email',
                selector: ':input[name="email"]',
                infoText: 'e.g. abc@xyz.com...',
                size: 'large',
                maxLength: 75,
                validate: {
                    required: true,
                    email: true,
                    remote: {
                        url: el8.service.urls.get('validEmail'),
                        type: 'GET'
                    }
                },
                validateMsgs: {
                    required: 'Required Field',
                    remote: 'Email Already Taken'
                }
            },
            {
                name: 'password1',
                selector: ':input[name="password1"]',
                infoText: 'Your password...',
                size: 'large',
                maxLength: 20,
                validate: {
                    required: true
                },
                validateMsgs: {
                    required: 'Required Field'
                }
            },
            {
                name: 'password2',
                selector: ':input[name="password2"]',
                infoText: 'Your password again...',
                size: 'large',
                maxLength: 20,
                validate: {
                    required: true
                },
                validateMsgs: {
                    required: 'Required Field'
                }
            }
        ]
    });

    var super_init = that._init;
    that._init = function() {

        super_init.call(that);

        (new el8.uiwidget.NewPasswordFields({
            field1: $(':input[name="password1"]', $container),
            selectorFn1: function($elt) { return $elt.prevAll('.error-msg'); },
            field2: $(':input[name="password2"]', $container),
            selectorFn2: function($elt) { return $elt.prevAll('.error-msg'); }
        })).init();

        $container.on('click', '.wrong-profile-trigger',  function() {
            that._hideEmailPassword();
            that._removeSignupButton();
            that._hideProfileDisplay();
            that.focusField('profileSearch');

        }).on('click', '.not-doctor-trigger',  function() {
            el8.ext.onboarding.notDoctorDialog.show();
        });
    };

    /**
     * Get invitation id from cookie, if exists
     */
    that._getInvitation = function() {
        return Cookies.get("invitation") || null;
    };
    that._getUtmData = function() {
        var utmData = Cookies.get("utm");
        return utmData || null;
    };

    /**
     * Manage show/hide of the email/password sections
     */
    that._showEmailPassword = function() {
        $emailPwd.show();
        var exploreEmail = Cookies.get("exploreEmail");
        if (exploreEmail) { that.setVal('email', exploreEmail); }
        that.focusField('email');
    };
    that._hideEmailPassword = function() {
        $emailPwd.hide();
    };

    /**
     * Manage show/hide signup button
     */
    that._addSignupButton = function() {
        that.addButton('signup', 'Sign Up', function(_form, $btn) {
            if (that.isValid()) {
                $btn.prop('disabled', true);
                var mapped = {};
                mapped['profile_id'] = _profileId;
                mapped['email'] = _form.getVal('email');
                mapped['password'] = _form.getVal('password1');
                mapped['complete'] = true;
                var invitation = that._getInvitation();
                mapped['invitation_id'] = invitation ? invitation['id'] : null;
                mapped['campaign'] = invitation ? invitation['campaign'] : null;

                var utmData = that._getUtmData();
                if (utmData) { mapped['utm_data'] = utmData; }

                var activating = el8.util.getUrlParam('activate');
                $.el8_ajax({
                    type: 'POST',
                    async: false, // need to have an ID
                    data: {data: JSON.stringify(mapped)},
                    url: el8.service.urls.get('signup', [null, activating]),
                    success: function(data) {
                        that._writeSignedUpCookie();
                        window.location.href = el8.service.urls.get('signupComplete', [activating]);
                    },
                    error: function() {
                        window.location.href = el8.service.urls.get('signupError', [activating]);
                    }
                });
            }
        }, true, true);
        that.renderButtonSet();
    };
    that._removeSignupButton = function() {
        that.removeButton('signup');
        that.renderButtonSet();
    };
    that._writeSignedUpCookie = function() {
        var cookieSettings = {
            expires : 30, // # days in future
            path : '/',
            domain : '.elationemr.com'
        };
        Cookies.set("testAccountCreated", true, cookieSettings);
    };

    /**
     * Validate inputs
     */
    var super_isValid = that.isValid;
    that.isValid = function() { // over-ride
        return super_isValid.call(that) && !$('.has-error', $container).length;
    };
    that._validateProfile = function(profile, validCb, invalidCb) {
        $.el8_ajax({
            type: 'GET',
            url: el8.service.urls.get('validNpi'),
            data: {'npi': profile.npi},
            success: function(data) {
                if (data) {
                    validCb(profile);
                } else {
                    invalidCb(profile);
                }
            },
            error: function() {
                window.location.href = el8.service.urls.get('signupError', [el8.util.getUrlParam('activate')]);
            }
        });
    };

    /**
     * Manage the showing/hiding of the profile selection
     */
    that._waitProfileDisplay = function() {
        $searchArea.hide();
        $profileDisplay.show().addClass('el8OBLoading')
            .html(el8.template.ext.onboarding.identityForm.verifying());
    };
    that._showProfileDisplay = function(item, isTaken) {

        $searchArea.hide();
        $profileDisplay.removeClass('el8OBLoading');

        $profileDisplay.html(
            el8.template.ext.onboarding.identityForm.profileDisplay({
                item: item,
                isTaken: isTaken,
                noCreds: true
            })
        ).show();

        if (!isTaken) {
            that._showEmailPassword();
            that._addSignupButton();
        }
    };
    that._hideProfileDisplay = function() {
        $profileDisplay.empty().hide();
        $searchArea.show();
        that.focusField('profileSearch');
    };

    that.render();
    that.focusField('profileSearch');
};
